module.exports = __webpack_public_path__ + "static/media/namecard_no_name.0fe1430e.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/namecard_no_name.svg
 ** module id = 906
 ** module chunks = 44
 **/